import { render, staticRenderFns } from "./OneSn.vue?vue&type=template&id=2853eeb6&scoped=true&"
import script from "./OneSn.vue?vue&type=script&lang=js&"
export * from "./OneSn.vue?vue&type=script&lang=js&"
import style0 from "./OneSn.vue?vue&type=style&index=0&id=2853eeb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2853eeb6",
  null
  
)

export default component.exports